<template>
    <rkm-modal
        :buttons="['save']"
        buttonSaveText="Continuar"
        title="Preferência de impressão"
        noCloseOnEsc
        noCloseOnBackdrop
        @save="save"
        ref="Modal"
    >
        <rkm-alert class="mb-3">
            <strong>Independente do Layout selecionado, a orientação da impressão deverá ser selecionada manualmente no momento da impressão.</strong>
        </rkm-alert>

        <rkm-form ref="Form">
            <rkm-col class="flex-grow-0">
                <rkm-form-radio-group v-model="selectedOrientation">
                    <rkm-form-radio :value="enums.orientacaoImpressao.RETRATO">Retrato</rkm-form-radio>
                    <rkm-form-radio :value="enums.orientacaoImpressao.PAISAGEM">Paisagem</rkm-form-radio>
                </rkm-form-radio-group>
            </rkm-col>
        </rkm-form>

    </rkm-modal>
</template>

<script>
//Enums
import orientacaoImpressao from '@/enums/geral/orientacaoImpressao'

export default {
    created() {
        this.selectedOrientation = this.enums.orientacaoImpressao.RETRATO;
    },
    data: () => ({
        selectedOrientation: null,
        enums: {
            orientacaoImpressao
        },
    }),
    methods: {
        open() {
            this.$refs.Modal.show()
        },
        save() {
            this.$emit('orientation', this.selectedOrientation);
            this.$emit('completed');
            this.$refs.Modal.hide();
        }
    }
}
</script>
